import { render, staticRenderFns } from "./PublicHead.vue?vue&type=template&id=5585ab46"
import script from "./PublicHead.vue?vue&type=script&lang=js"
export * from "./PublicHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports